module.exports = __webpack_public_path__ + "img/settings.66283ad4.svg";